import { render, staticRenderFns } from "./SettingsAttachmentsFolder.vue?vue&type=template&id=029f6eb2"
import script from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"
export * from "./SettingsAttachmentsFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports